import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function CustomDesign() {
  const [form, setForm] = useState({ name:"", email:"", description:"", apparel_type:"tshirt" });
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setUploading(true);
    try {
      const paths = [];
      for (const f of files) {
        const fd = new FormData(); fd.append("file", f);
        const r = await api.post("/custom-design/upload", fd, { headers: {"Content-Type":"multipart/form-data"} });
        paths.push(r.data.path);
      }
      await api.post("/custom-design", { ...form, image_paths: paths });
      setDone(true);
      toast.success("Request submitted");
    } catch { toast.error("Submission failed"); }
    finally { setUploading(false); }
  };

  if (done) return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="custom-design-success">
      <h1 className="font-display text-5xl text-[color:var(--hb-navy)]">Request Received</h1>
      <p className="text-sm text-neutral-600 mt-4">We'll review your idea and reach out within 1–2 business days. A $5.00 design fee applies to custom orders.</p>
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="custom-design-page">
      <div className="text-xs tracking-[0.35em] uppercase text-neutral-500 mb-2">Made for You</div>
      <h1 className="font-display text-6xl text-[color:var(--hb-navy)]">Custom Design Request</h1>
      <p className="mt-4 text-neutral-700 max-w-xl">Tell us your vision. Upload photos, sketches, or a description — our team will bring it to life on premium apparel. A $5.00 design service fee applies.</p>

      <form onSubmit={submit} className="mt-10 grid gap-5">
        <input required placeholder="Your name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})}
          className="border-b border-neutral-300 py-3" data-testid="cd-name"/>
        <input required type="email" placeholder="Email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})}
          className="border-b border-neutral-300 py-3" data-testid="cd-email"/>
        <select value={form.apparel_type} onChange={e=>setForm({...form,apparel_type:e.target.value})} className="border-b border-neutral-300 py-3 bg-transparent" data-testid="cd-apparel">
          {["tshirt","hoodie","crewneck","longsleeve","tank","hat","totebag"].map(a=><option key={a} value={a}>{a}</option>)}
        </select>
        <textarea required rows="6" placeholder="Describe your design idea…" value={form.description} onChange={e=>setForm({...form,description:e.target.value})}
          className="border-b border-neutral-300 py-3" data-testid="cd-description"/>
        <div>
          <label className="block text-xs uppercase tracking-widest text-neutral-500 mb-2">Upload photos or sketches (optional)</label>
          <input type="file" multiple accept="image/*" onChange={e=>setFiles(Array.from(e.target.files))} data-testid="cd-files"/>
          <div className="text-xs text-neutral-500 mt-1">{files.length} file(s) selected</div>
        </div>
        <button disabled={uploading} className="hb-btn-primary w-fit" data-testid="cd-submit">{uploading ? "Submitting…" : "Submit Request"}</button>
      </form>
    </div>
  );
}
